import React, { FC, SVGProps } from 'react';

export const Personalized: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width="80" height="80" rx="40" fill="#B1CB8F" />
    <rect
      x="60"
      y="26"
      width="32"
      height="40"
      rx="10"
      transform="rotate(90 60 26)"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M49.8261 26C55.445 26 60 30.555 60 36.1739V36.1739C60 40.4961 56.4961 44 52.1739 44L27.8261 44C23.5039 44 20 40.4961 20 36.1739V36.1739C20 30.555 24.555 26 30.1739 26L49.8261 26Z"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <path
      d="M49 26V26C49 22.6863 46.3137 20 43 20L37 20C33.6863 20 31 22.6863 31 26V26L49 26Z"
      stroke="#26313B"
      strokeWidth="2"
      strokeLinejoin="round"
    />
    <circle
      cx="40"
      cy="44"
      r="6"
      fill="#FFCFAD"
      stroke="#26313B"
      strokeWidth="2"
    />
  </svg>
);
